import {
	MAX_GUEST_AUTH_TTL_DAYS,
	MIN_GUEST_AUTH_TTL_DAYS,
} from '../types/organization-config.interface';

export function guestAuthTtlHoursToDays(hours: number): number {
	return Math.max(
		MIN_GUEST_AUTH_TTL_DAYS,
		Math.min(MAX_GUEST_AUTH_TTL_DAYS, Math.round(hours / 24)),
	);
}

export function guestAuthTtlDaysToHours(days: number): number {
	return Math.floor(days) * 24;
}

export function isGuestAuthTtlDaysInRange(value: number): boolean {
	return (
		Number.isInteger(value) &&
		value >= MIN_GUEST_AUTH_TTL_DAYS &&
		value <= MAX_GUEST_AUTH_TTL_DAYS
	);
}
